import type { Locale } from '../type';

const localeValues: Locale = {
  locale: 'de',
  Pagination: {
    items_per_page: '/ Seite',
    jump_to: 'Gehe zu',
    jump_to_confirm: 'bestätigen',
    page: '',
    prev_page: 'Vorherige Seite',
    next_page: 'Nächste Seite',
    prev_5: '5 Seiten zurück',
    next_5: '5 Seiten vor',
    prev_3: '3 Seiten zurück',
    next_3: '3 Seiten vor',
  },
  DatePicker: {
    lang: {
      placeholder: 'Datum auswählen',
      rangePlaceholder: [
        'Startdatum',
        'Enddatum',
      ],
      locale: 'de_DE',
      today: 'Heute',
      now: 'Jetzt',
      backToToday: 'Zurück zu Heute',
      ok: 'OK',
      clear: 'Zurücksetzen',
      month: 'Monat',
      year: 'Jahr',
      timeSelect: 'Zeit wählen',
      dateSelect: 'Datum wählen',
      monthSelect: 'Wähle einen Monat',
      yearSelect: 'Wähle ein Jahr',
      decadeSelect: 'Wähle ein Jahrzehnt',
      yearFormat: 'YYYY',
      dateFormat: 'D.M.YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D.M.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Vorheriger Monat (PageUp)',
      nextMonth: 'Nächster Monat (PageDown)',
      previousYear: 'Vorheriges Jahr (Ctrl + left)',
      nextYear: 'Nächstes Jahr (Ctrl + right)',
      previousDecade: 'Vorheriges Jahrzehnt',
      nextDecade: 'Nächstes Jahrzehnt',
      previousCentury: 'Vorheriges Jahrhundert',
      nextCentury: 'Nächstes Jahrhundert',
    },
    timePickerLocale: {
      placeholder: 'Zeit auswählen',
    },
  },
  TimePicker: {
    placeholder: 'Zeit auswählen',
  },
  Calendar: {
    lang: {
      placeholder: 'Datum auswählen',
      rangePlaceholder: [
        'Startdatum',
        'Enddatum',
      ],
      locale: 'de_DE',
      today: 'Heute',
      now: 'Jetzt',
      backToToday: 'Zurück zu Heute',
      ok: 'OK',
      clear: 'Zurücksetzen',
      month: 'Monat',
      year: 'Jahr',
      timeSelect: 'Zeit wählen',
      dateSelect: 'Datum wählen',
      monthSelect: 'Wähle einen Monat',
      yearSelect: 'Wähle ein Jahr',
      decadeSelect: 'Wähle ein Jahrzehnt',
      yearFormat: 'YYYY',
      dateFormat: 'D.M.YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D.M.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Vorheriger Monat (PageUp)',
      nextMonth: 'Nächster Monat (PageDown)',
      previousYear: 'Vorheriges Jahr (Ctrl + left)',
      nextYear: 'Nächstes Jahr (Ctrl + right)',
      previousDecade: 'Vorheriges Jahrzehnt',
      nextDecade: 'Nächstes Jahrzehnt',
      previousCentury: 'Vorheriges Jahrhundert',
      nextCentury: 'Nächstes Jahrhundert',
    },
    timePickerLocale: {
      placeholder: 'Zeit auswählen',
    },
  },
  global: {
    placeholder: 'Bitte auswählen',
  },
  Table: {
    filterTitle: 'Filter-Menü',
    filterConfirm: 'OK',
    filterReset: 'Zurücksetzen',
    selectAll: 'Selektiere Alle',
    selectInvert: 'Selektion Invertieren',
    selectionAll: 'Wählen Sie alle Daten aus',
    sortTitle: 'Sortieren',
    expand: 'Zeile erweitern',
    collapse: 'Zeile reduzieren',
    triggerDesc: 'Klicken zur absteigenden  Sortierung',
    triggerAsc: 'Klicken zur aufsteigenden Sortierung',
    cancelSort: 'Klicken zum Abbrechen der Sortierung',
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Abbrechen',
    justOkText: 'OK',
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Abbrechen',
  },
  Transfer: {
    titles: [
      '',
      '',
    ],
    searchPlaceholder: 'Suchen',
    itemUnit: 'Eintrag',
    itemsUnit: 'Einträge',
    remove: 'Entfernen',
    selectCurrent: 'Alle auf aktueller Seite auswählen',
    removeCurrent: 'Auswahl auf aktueller Seite aufheben',
    selectAll: 'Alle auswählen',
    removeAll: 'Auswahl aufheben',
    selectInvert: 'Auswahl umkehren',
  },
  Upload: {
    uploading: 'Hochladen...',
    removeFile: 'Datei entfernen',
    uploadError: 'Fehler beim Hochladen',
    previewFile: 'Dateivorschau',
    downloadFile: 'Download-Datei',
  },
  Empty: {
    description: 'Keine Daten',
  },
  Text: {
    edit: 'Bearbeiten',
    copy: 'Kopieren',
    copied: 'Kopiert',
    expand: 'Erweitern',
  },
  PageHeader: {
    back: 'Zurück',
  },
  Form: {
    defaultValidateMessages: {
      default: 'Feld-Validierungsfehler: ${label}',
      required: 'Bitte geben Sie ${label} an',
      enum: '${label} muss eines der folgenden sein [${enum}]',
      whitespace: '${label} darf kein Leerzeichen sein',
      date: {
        format: '${label} ist ein ungültiges Datumsformat',
        parse: '${label} kann nicht in ein Datum umgewandelt werden',
        invalid: '${label} ist ein ungültiges Datum',
      },
      types: {
        string: '${label} ist nicht gültig. ${type} erwartet',
        method: '${label} ist nicht gültig. ${type} erwartet',
        array: '${label} ist nicht gültig. ${type} erwartet',
        object: '${label} ist nicht gültig. ${type} erwartet',
        number: '${label} ist nicht gültig. ${type} erwartet',
        date: '${label} ist nicht gültig. ${type} erwartet',
        boolean: '${label} ist nicht gültig. ${type} erwartet',
        integer: '${label} ist nicht gültig. ${type} erwartet',
        float: '${label} ist nicht gültig. ${type} erwartet',
        regexp: '${label} ist nicht gültig. ${type} erwartet',
        email: '${label} ist nicht gültig. ${type} erwartet',
        url: '${label} ist nicht gültig. ${type} erwartet',
        hex: '${label} ist nicht gültig. ${type} erwartet',
      },
      string: {
        len: '${label} muss genau ${len} Zeichen lang sein',
        min: '${label} muss mindestens ${min} Zeichen lang sein',
        max: '${label} darf höchstens ${max} Zeichen lang sein',
        range: '${label} muss zwischen ${min} und ${max} Zeichen lang sein',
      },
      number: {
        len: '${label} muss gleich ${len} sein',
        min: '${label} muss mindestens ${min} sein',
        max: '${label} darf maximal ${max} sein',
        range: '${label} muss zwischen ${min} und ${max} liegen',
      },
      array: {
        len: 'Es müssen ${len} ${label} sein',
        min: 'Es müssen mindestens ${min} ${label} sein',
        max: 'Es dürfen maximal ${max} ${label} sein',
        range: 'Die Anzahl an ${label} muss zwischen ${min} und ${max} liegen',
      },
      pattern: {
        mismatch: '${label} enspricht nicht dem ${pattern} Muster',
      },
    },
  },
  Image: {
    preview: 'Vorschau',
  },
};

export default localeValues;
